module.exports = __webpack_public_path__ + "img/section2_icon_money.47c732c3.svg";